/**
 * Login Page
 * ==========
 * صفحة تسجيل الدخول
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../context/ToastContext';
import { Button } from '../../../lib/ui/Button';
import { Input } from '../../../lib/ui/Input';
import { Checkbox } from '../../../lib/ui/Checkbox';
import './LoginPage.css';

const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const toast = useToast();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};

    if (!email) {
      newErrors.email = 'البريد الإلكتروني مطلوب';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = 'البريد الإلكتروني غير صالح';
    }

    if (!password) {
      newErrors.password = 'كلمة المرور مطلوبة';
    } else if (password.length < 6) {
      newErrors.password = 'كلمة المرور يجب أن تكون 6 أحرف على الأقل';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);
    setErrors({});

    try {
      const result = await login(email, password);

      if (result.success) {
        toast.success('تم تسجيل الدخول بنجاح');
        navigate('/admin/dashboard');
      } else {
        setErrors({ general: result.error });
        toast.error(result.error);
      }
    } catch (error) {
      const errorMessage = 'حدث خطأ أثناء تسجيل الدخول';
      setErrors({ general: errorMessage });
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="watrly-login">
      <div className="watrly-login__header">
        <h2 className="watrly-login__title">تسجيل الدخول</h2>
        <p className="watrly-login__subtitle">أدخل بياناتك للوصول إلى لوحة التحكم</p>
      </div>

      <form className="watrly-login__form" onSubmit={handleSubmit}>
        {errors.general && (
          <div className="watrly-login__error-banner">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
            <span>{errors.general}</span>
          </div>
        )}

        <Input
          label="البريد الإلكتروني"
          type="email"
          placeholder="admin@watrly.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          error={errors.email}
          disabled={loading}
          icon={
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
              <polyline points="22,6 12,13 2,6" />
            </svg>
          }
        />

        <Input
          label="كلمة المرور"
          type="password"
          placeholder="••••••••"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          error={errors.password}
          disabled={loading}
        />

        <div className="watrly-login__options">
          <Checkbox
            label="تذكرني"
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
            size="sm"
            variant="water-drop"
          />
          <a href="#forgot" className="watrly-login__forgot">
            نسيت كلمة المرور؟
          </a>
        </div>

        <Button
          type="submit"
          variant="primary"
          size="lg"
          fullWidth
          loading={loading}
        >
          تسجيل الدخول
        </Button>
      </form>

      <div className="watrly-login__footer">
        <p>للدعم الفني: <a href="mailto:support@watrly.com">support@watrly.com</a></p>
      </div>
    </div>
  );
};

export default LoginPage;
